
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Baseservice } from './baseservice';

import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class VehicleEntryService extends Baseservice {

  constructor(http:HttpClient,authentication:AuthenticationService) {
    super("vehicle-entry",http,authentication)
   }

getVehicles(){      
  //alert(this.url);
    return this.http.get(this.url);
}
getVehicleEntryById(id){
  return this.http.get(this.url+"/"+id);
}
postVehicleEntry(object : any,id,appid) {
  let body = object;
  return this.http.post(this.url+'/'+id+'/'+appid,body);
}///carrier/
postCarrierVehicleEntry(object : any,id) {
  let body = object;
  return this.http.post(this.url+'/carrier/'+id,body);
}
searchVehicle(object : any) {
  let body = object;
  //console.log("Calling the search function");
  return this.http.post(this.url+"/search", body);
}
searchExternalVehicle(object : any) {
  let body = object;
  //console.log("Calling the search function");
  return this.http.post(this.url+"/external/search", body);
}
searchCarrierVehicle(object : any) {
  let body = object;
  return this.http.post(this.url+"/carrier-search", body);
}

checkVehicles(data,id){  
  return this.http.post(this.url + '/check/'+id,data);
}
replaceVehicles(data,id){
  return this.http.post(this.url + '/replace/'+id,data);
}
//replace
deletevehicle(object){
  return this.http.post(this.url + '/delete',object);
}
getAllVehicleEntry(){
  return this.http.get(this.url+'/all');
}
UpdateVehicleEntry(object : any,id,appid) {
  let body = object;
  return this.http.put(this.url+'/'+id+'/'+appid,body);
}
getVehicleDeatilsById(id){
  return this.http.get(this.url+'/veh/'+id);
}
checkVehicleApplication(data,carrierId){
  return this.http.post(this.url+'/vehicle-application/'+carrierId,data);

}
vehicleApplicationForeign(data,carrier){
  return this.http.post(this.url+'/vehicle-application-foreign/'+carrier,data);

}
getCarrierVehiclesList(id){
  return this.http.get(this.url+"/carrier/list/"+id);
}
}
